export default "__VITE_ASSET__DX7iNy0m__"